import type { ContentEntry } from '../types/curriculum'

export const curriculum: ContentEntry[] = [
  {
    title: 'TOMO 1 — Fundamentos de la postura',
    groups: [
      {
        items: [
          'Anatomía postural y cadenas musculares.',
          'Cadenas anterior, posterior y cruzadas.',
          'Ejes y planos corporales.',
          'Test visual.',
          'Fotografías comparativas.',
          'Evaluación con plomada.',
          'Apps de análisis postural.',
        ],
      },
    ],
  },
  {
    title: 'TOMO 2 — Desalineaciones y patologías más comunes',
    groups: [
      {
        items: [
          'Hipercifosis.',
          'Hiperlordosis.',
          'Escoliosis.',
          'Anteproyección cervical.',
          'Báscula pélvica.',
          'Pie plano.',
          'Pie cavo.',
          'Genu valgo.',
          'Genu varo.',
          'Causas frecuentes.',
          'Abordaje desde el ejercicio.',
        ],
      },
    ],
  },
  {
    title: 'TOMO 3 — Gimnasia postural según población',
    groups: [
      {
        items: [
          'Niños y adolescentes.',
          'Oficinistas y sedentarios.',
          'Adultos mayores.',
          'Embarazadas.',
          'Deportistas.',
          'Adaptaciones según población.',
        ],
      },
    ],
  },
  {
    title: 'TOMO 4 — Rutinas y ejercicios correctivos por zona',
    groups: [
      {
        items: [
          'Cervical.',
          'Dorsal y escápulas.',
          'Lumbar.',
          'Cadera.',
          'Miembros inferiores.',
          'Progresiones.',
          'Uso de materiales.',
          'Clases individuales y grupales.',
        ],
      },
    ],
  },
  {
    title: 'TOMO 5 — Reeducación postural y técnicas complementarias',
    groups: [
      {
        items: [
          'Introducción a RPG.',
          'Conceptos de Mézières.',
          'Pilates postural.',
          'Trabajo respiratorio.',
          'Conciencia corporal.',
        ],
      },
    ],
  },
  {
    title: 'TOMO 6 — Programación, seguimiento y negocio',
    groups: [
      {
        items: [
          'Clases grupales e individuales.',
          'Evaluación inicial.',
          'Reevaluación a 30, 60 y 90 días.',
          'Registro del antes y después.',
          'Armado de paquetes.',
          'Fidelización.',
          'Trabajo interdisciplinario.',
        ],
      },
    ],
  },
  {
    title: 'TOMO 7 — Movilidad y Stretching Aplicado a la Gimnasia Postural',
    groups: [
      {
        heading: 'Unidad 1. Introducción a la movilidad',
        items: [
          '1.1. Concepto de movilidad articular.',
          '1.2. Diferencias entre movilidad y flexibilidad.',
          '1.3. Beneficios de la movilidad para la postura.',
          '1.4. Indicaciones y contraindicaciones.',
        ],
      },
      {
        heading: 'Unidad 2. Stretching activo',
        items: [
          '2.1. Principios del stretching activo.',
          '2.2. Beneficios.',
          '2.3. Indicaciones.',
          '2.4. Ejercicios por región corporal.',
        ],
      },
      {
        heading: 'Unidad 3. Stretching pasivo',
        items: [
          '3.1. Fundamentos.',
          '3.2. Tiempos de aplicación.',
          '3.3. Precauciones.',
          '3.4. Errores frecuentes.',
        ],
      },
      {
        heading: 'Unidad 4. Movilidad articular por segmentos',
        items: [
          '4.1. Columna cervical.',
          '4.2. Columna dorsal.',
          '4.3. Columna lumbar.',
          '4.4. Cintura escapular.',
          '4.5. Caderas.',
          '4.6. Rodillas.',
          '4.7. Tobillos.',
        ],
      },
      {
        heading: 'Unidad 5. Integración en la gimnasia postural',
        items: [
          '5.1. Organización de una sesión.',
          '5.2. Progresiones.',
          '5.3. Adaptaciones según el alumno.',
          '5.4. Combinación con ejercicios correctivos.',
        ],
      },
      {
        heading: 'Unidad 6. Trabajo respiratorio',
        items: [
          '6.1. Respiración diafragmática.',
          '6.2. Coordinación respiración-movimiento.',
          '6.3. Técnicas de relajación.',
        ],
      },
      {
        heading: 'Unidad 7. Errores frecuentes',
        items: [
          '7.1. Compensaciones habituales.',
          '7.2. Exceso de intensidad.',
          '7.3. Progresiones inadecuadas.',
          '7.4. Estrategias de corrección.',
        ],
      },
    ],
  },
]
